var CurrentUser = require("lib/account/CurrentUser");

var PaginationControls = require("components/utility/PaginationControls");
var Spinner = require("components/utility/Spinner");

import ReactSelect from "react-select";

class CleverListEvents extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		
		this.state = { events: {}, loading: true, page: 1, total: 0, selectedCategory: "all"}
	}

	onPageChange(page) {
		var formerPage = this.state.page
		console.log(page, formerPage)
	    this.setState({ page }, () => {
	    	console.log(page > formerPage)
	    	if (page > formerPage) {
	    		this.loadEvents(false);
	    	}
	    });
	}

	renderEvents() {

		var eventChunk = _.chunk(_.values(this.state.events), PER_PAGE)[this.state.page - 1]
		var rows = _.map(eventChunk, (event, e) => {

			if (event.data && event.data.previous_attributes) {
				var data = event.data.object.id + " - " + JSON.stringify(_.keys(event.data.previous_attributes))
			} else {
				var data = event.data.object.id
			}

			return (
				<tr key={e}>
					<td>
						{ event.processed }
					</td>
					<td>
						{ (new Date(event.created)).toLocaleString() }
					</td>
					<td>
						{ event.id }
					</td>
					<td>
						{ event.category }
					</td>
					<td>
						{ data }
					</td>
				</tr>
			)
		})

		return (
			<div>
				<table className="table">
					<thead>
						<tr>
							<th>
								Processed
							</th>
							<th>
								Created At
							</th>
							<th>
								ID
							</th>
							<th>
								Category
							</th>
							<th>
								Data
							</th>
						</tr>
					</thead>
					<tbody>
						{ rows }
					</tbody>
				</table>
				<PaginationControls 
					page={this.state.page}
					perPage={PER_PAGE}
					totalCount={this.state.total}
					onPageChange={this.onPageChange} />
			</div>
		)

	}
	
	onSelectCategory(category) {
		this.setState({selectedCategory: category.value})
	}

	renderFilters() {
		var options = _.map(EVENTS, (event) => {
			return {value: event, label: event}
		})

		return (
			<div style={{marginBottom: "20px"}}>
				<table className="table">
					<thead>
						<tr>
							<th>
								Start Date
							</th>
							<th>
								End Date
							</th>
							<th>
								Category
							</th>
							<th>
							</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>
								<input type="date" className="form-control" id="start-date" ref="start_date" />
							</td>
							<td>
								<input type="date" className="form-control" id="end-date" ref="end_date" />
							</td>
							<td>
								<ReactSelect name="subject" id="category" value={ this.state.selectedCategory }
									options={ options } onChange={ this.onSelectCategory.bind(this) } />
							</td>
							<td>
								<button className="btn btn-primary" onClick={() => {this.loadEvents(true)}}>Filter</button>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		)
	}

	render() {

		if (_.keys(this.state.events).length > 0) {
			var view = this.renderEvents()
			if (this.state.loading) {
				var loader = <Spinner placeholder={ true } scale={ 0.5 } />
			}
		} else {
			var loader = <Spinner placeholder={ true } scale={ 0.5 } />
		}
		

		return (
			<div className="CleverListEvents">
				<h2>7 - List Events</h2>
				{ loader }
				{ this.renderFilters() }
				{ view }

			</div>
		);
	}

	componentDidMount() {
		this.loadEvents(false)
	}

	loadEvents(reset) {

		if (reset) {
			this.setState({loading: true, page: 1, events: {}})
		} else {
			this.setState({loading: true})
		}
		var params = {page: this.state.page, per_page: PER_PAGE, clever_district_id: this.props.accessToken.district.clever_id, embed:"clever_event.data"}

		if (this.state.selectedCategory != "all") {
			params["category"] = this.state.selectedCategory
		}

		if (this.refs.start_date.value != "") {
			params["start_date"] = this.refs.start_date.value
		}
		if (this.refs.end_date.value != "") {
			params["end_date"] = this.refs.end_date.value
		}


		CurrentUser.api().getCleverEvents(params, $wr.apiHandler((response) => {
			var events = this.state.events
			if (response.clever_events.length > 0) {
				_.each(response.clever_events, (event) => {
					events[event.id] = event
				})
				this.setState({ events, loading: false, total: response.total})
			} else {
				this.setState({loading: false})
			}
		}));
	}
};

var PER_PAGE = 40;

var EVENTS =  ["all","students.deleted", "contacts.created", "students.created", "districts.updated", "sections.deleted", "districtadmins.created", "sections.updated", "teachers.created", "contacts.deleted", "schools.created", "contacts.updated", "sections.created", "students.updated", "teachers.deleted", "schooladmins.deleted", "districtadmins.deleted", "terms.created", "courses.created", "schooladmins.updated", "schools.deleted", "schooladmins.created", "districts.created", "teachers.updated", "courses.deleted", "terms.deleted"]

CleverListEvents.propTypes = PageStrictPropTypes({
});

module.exports = CleverListEvents;


// WEBPACK FOOTER //
// ./modules/components/appdev/wizards/CleverListEvents.js